import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import tokens from '../theme/tokens';

const MAX_PLAYERS = 6;

// Pote da votação: recebe jogadores via drag-and-drop e mostra a lotação (x/6).
const Pot = ({ potNum, playersInPot, onDrop, onPlayerRemove, showRemove, active }) => {
  const full = playersInPot.length === MAX_PLAYERS;

  return (
    <Box
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => onDrop && onDrop(e, potNum)}
      sx={{
        height: '100%',
        minHeight: 220,
        borderRadius: 3,
        border: '2px solid',
        borderColor: full ? tokens.color.success : active ? tokens.color.brand : tokens.color.border,
        bgcolor: full ? tokens.color.successSoft : tokens.color.surface,
        borderStyle: onDrop && !full ? 'dashed' : 'solid',
        transition: 'border-color .2s, background-color .2s',
        overflow: 'hidden',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 1.5, py: 1, bgcolor: full ? tokens.color.success : active ? tokens.color.brand : tokens.color.ink, color: '#fff' }}>
        <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: '1.2rem' }}>Pote {potNum}</Typography>
        <Typography variant="body2" fontWeight={700}>{playersInPot.length}/{MAX_PLAYERS}</Typography>
      </Stack>
      <Stack spacing={0.5} sx={{ p: 1 }}>
        {playersInPot.map((player, index) => (
          <Stack key={`${player}-${index}`} direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1, py: 0.5, borderRadius: 1.5, bgcolor: tokens.color.surfaceAlt }}>
            <Typography variant="body2" fontWeight={500} noWrap title={player}>{player}</Typography>
            {showRemove && (
              <Tooltip title="Remover">
                <IconButton size="small" onClick={(e) => onPlayerRemove(e, potNum, player)}>
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        ))}
        {playersInPot.length === 0 && (
          <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 3 }}>
            {onDrop ? 'Arraste jogadores para cá' : 'Vazio'}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default Pot;
